export default __webpack_public_path__ + "static/media/GEIST.d21adaca.svg";